"use strict";

import module from "./module.js";
import "./module.spec.js";

export default module;
